import { useCallback } from "react";

import { useInvalidateProducts } from "~/api/products/hooks/use-invalidate-products";

import { kioskActions } from "../actions";

import { useKioskSession } from "./use-kiosk-session";

export const useKioskSessionReset = () => {
  const childId = useKioskSession((state) => state?.childId);

  const invalidateProducts = useInvalidateProducts();

  return useCallback(() => {
    invalidateProducts(childId);
    kioskActions.session.reset();
  }, [childId, invalidateProducts]);
};
